import { IconButton, IconButtonProps } from '@amzn/ring-ui-react-components';
import { Icon } from 'src/shared/components/Icon';

export interface UploadYourVideoFABProps extends IconButtonProps {
  onClick?: () => void;
}

export const UploadYourVideoFAB = ({
  onClick,
  ...props
}: UploadYourVideoFABProps) => (
  <IconButton
    {...props}
    isRound={true}
    size="xs"
    onClick={onClick}
    width="64px"
    height="64px"
    position="fixed"
    right="12px"
    bottom="12px"
    zIndex="5"
    icon={<Icon name="add" color="white" size={24} />}
  />
);
